import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-scpc-bvs',
  templateUrl: './consulta-scpc-bvs.component.html',
  styleUrls: ['./consulta-scpc-bvs.component.scss']
})
export class ConsultaScpcBvsComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="REGISTRO SCPC BVS";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {

    if(!this.consulta.registros || this.consulta.registros.length == 0) {
      this.codigoControle = 'SEMREGISTRO_OK';
    }

    if(this.codigoControle == "SEMREGISTRO_OK") {
      this.status = 'success';
    }
  }

}
